import { useState, useRef, useEffect } from "react";
import { Globe, Check, ChevronDown } from "lucide-react";
import { LOCALES } from "../i18n/config";
import { useI18n } from "../i18n/LanguageProvider";

export function LanguageSwitcher({ dark = false }) {
  const { locale, changeLocale } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const current = LOCALES.find((l) => l.code === locale);
  const txt = dark ? "text-white/80 hover:text-white" : "text-black/70 hover:text-black";

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        data-testid="language-switcher-button"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
        className={`flex items-center gap-1.5 rounded-full px-3 py-2 text-sm font-medium transition-colors duration-200 ${txt}`}
      >
        <Globe strokeWidth={1.5} className="h-4 w-4" />
        <span className="hidden sm:inline">{current?.flag}</span>
        <ChevronDown strokeWidth={1.5} className={`h-3.5 w-3.5 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div
          role="listbox"
          data-testid="language-switcher-menu"
          className="absolute right-0 z-50 mt-2 max-h-80 w-52 overflow-y-auto rounded-2xl border border-black/10 bg-white p-1.5 shadow-[0_20px_40px_rgba(0,0,0,0.12)]"
        >
          {LOCALES.map((l) => (
            <button
              key={l.code}
              type="button"
              role="option"
              aria-selected={l.code === locale}
              data-testid={`language-option-${l.code}`}
              onClick={() => {
                changeLocale(l.code);
                setOpen(false);
              }}
              className="flex w-full items-center justify-between rounded-xl px-3 py-2.5 text-left text-sm text-black/80 transition-colors duration-150 hover:bg-black/[0.04]"
            >
              <span>{l.label}</span>
              {l.code === locale && <Check strokeWidth={2} className="h-4 w-4 text-green" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
